import type { RunPhase } from './model';

export type MachinePhase='loading'|'title'|RunPhase|'fallback';
export type MachineEvent='READY'|'UNSUPPORTED'|'OPEN_PREFLIGHT'|'LAUNCH'|'PAUSE'|'RESUME'|'MOVEMENT_DONE'|'TRANSITION_DONE'|'FAIL'|'COMPLETE'|'FINALE_DONE'|'SHOW_RESULTS'|'RETRY'|'REPLAY';

const transitions:Record<MachinePhase,Partial<Record<MachineEvent,MachinePhase>>>= {
  loading:{READY:'title',UNSUPPORTED:'fallback'},fallback:{RETRY:'loading'},title:{OPEN_PREFLIGHT:'preflight'},preflight:{LAUNCH:'active'},
  active:{PAUSE:'paused',MOVEMENT_DONE:'transition',FAIL:'failed',COMPLETE:'finale',RETRY:'active'},
  transition:{PAUSE:'paused',TRANSITION_DONE:'active',FAIL:'failed',COMPLETE:'finale'},paused:{RESUME:'active',RETRY:'active'},
  failed:{RETRY:'active'},finale:{FINALE_DONE:'results',SHOW_RESULTS:'results'},results:{REPLAY:'preflight'},
};

export class AppStateMachine{
  public phase:MachinePhase='loading';
  public send(event:MachineEvent):MachinePhase{const next=transitions[this.phase][event];if(!next)throw new Error(`Invalid Astra Loom transition: ${this.phase} + ${event}`);this.phase=next;return next;}
  public force(phase:MachinePhase):void{this.phase=phase;}
}
